import { TaxSectionProps } from ".";
import { BankSlipConfig, FullSellerRatesHistory } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { BankSlipIcon } from "../../styles/icons/BankSlipIcon";
import { formatCurrency, getRateTypeValue } from "../../utils";
import { formatPaymentRangeFromApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Text } from "../Sellers/styles";
import { Divider, Header, Section } from "./styles";

interface BankSlipSection extends TaxSectionProps {
  bankSlipConfigData: BankSlipConfig;
  defaultBankSlipConfigData: BankSlipConfig;
  actualValue: FullSellerRatesHistory | undefined;
}

export function BankSlipModalVisualization({
  bankSlipConfigData,
  defaultBankSlipConfigData,
  colorFinder,
  actualValue,
}: BankSlipSection) {
  const delayForRedeem = formatTextView("bankSlipConfigData", "delayForRedeem", formatPaymentRangeFromApi);
  const value = formatBankSlipValueView("bankSlipConfigData", "value");
  const bankSlipLimitValue = formatTextView("bankSlipConfigData", "rate", formatCurrency, true);
  const rateType = formatTextView("bankSlipConfigData", "rateType", getRateTypeValue, false);

  function formatTextView(paymentMethod: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean ): JSX.Element {
    const pastValue = actualValue?.pastSellerRates?.[paymentMethod][innerValue];
    const laterValue = actualValue?.laterSellerRates?.[paymentMethod][innerValue];
    if (pastValue === laterValue) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {formaterAsCurrency ? formater({value: laterValue}) : formater(laterValue)}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultBankSlipConfigData[innerValue])}>
            {formaterAsCurrency ? formater({value: pastValue}) : formater(pastValue)}
          </Text>
          <ArrowIcon size={13}/>
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultBankSlipConfigData[innerValue])}>
            {formaterAsCurrency ? formater({value: laterValue}) : formater(laterValue)}
          </Text>
        </Section>
      );
    }
  }
  function formatBankSlipValueView(paymentMethod: string, innerValue: string) {
    const pastSellerRateType = actualValue?.pastSellerRates?.[paymentMethod]["rateType"];
    const laterSellerRateType = actualValue?.laterSellerRates?.[paymentMethod]["rateType"];
    const pastValue: any = pastSellerRateType === "percent" ? formatPercentageToNumber(actualValue?.pastSellerRates?.[paymentMethod][innerValue]) : formatCurrency({ value: actualValue?.pastSellerRates?.[paymentMethod][innerValue] });
    const laterValue: any = laterSellerRateType === "percent" ? formatPercentageToNumber(actualValue?.laterSellerRates?.[paymentMethod][innerValue]) : formatCurrency({value: actualValue?.laterSellerRates?.[paymentMethod][innerValue]});
    if (pastValue === laterValue) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue,defaultBankSlipConfigData[innerValue])}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultBankSlipConfigData[innerValue])}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }
  return (
    <>
      {bankSlipConfigData && (
        <Section flexDir="column">
          <Section gap=".4rem" margin="1rem 0 0">
            <BankSlipIcon />
            <Header>Boleto</Header>
          </Section>
          <Section flexDir="column">
            <Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Tempo de repasse
                </Text>
                {delayForRedeem}
              </Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Taxas
                </Text>
                {value}
              </Section>
            </Section>

            <Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Limite de taxas
                </Text>
                {bankSlipLimitValue}
              </Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Tipo de taxa
                </Text>
                {rateType}
              </Section>
            </Section>
          </Section>
          <Divider />
        </Section>
      )}
    </>
  )
}